import eventBus, { REMOVE_REQUEST_MESSAGES, SHOW_MESSAGE } from '@/util/eventBus';
import { getRequestKey } from '@/services/http-client';

export function mockRequest(
  data = null,
  status = 200,
  timeout = 500,
  method = 'GET',
  url = 'api/users'
) {
  eventBus.$emit(REMOVE_REQUEST_MESSAGES, getRequestKey({ method, url }));
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      if (status === 200 || status === 201) {
        resolve({
          status,
          data,
        });
      } else {
        const errors = data?.error || [];
        errors.forEach((e) => {
          if (!e.field) {
            eventBus.$emit(SHOW_MESSAGE, {
              type: 'error',
              requestKey: getRequestKey({ method, url }),
              text: e.message,
            });
          }
        });
        // eslint-disable-next-line prefer-promise-reject-errors
        reject({
          response: {
            status,
            data,
            config: {
              method,
              url,
            },
          },
        });
      }
    }, timeout);
  });
}
